<template>
  <div class="footerContain">
    <ul class="topFooter">
      <div class="topFooterDiv layout text_center font_s_14" style="position: relative">
        <li class="firstRow">
          <img src="@/assets/images/img_7.png" alt="">
          <p style="margin-left: 20px;padding: 10px">版权所有@浙江财经大学</p>
        </li>
        <li class="twoRow">
<!--          <h3>快速通道</h3>-->
          <ul class="text_center">
          <li>
            <p style="margin-bottom: 10px">
            地址:浙江省杭州市下沙高教园区学源街18号
            </p>
            <p>
             电话：0571-87557012  邮编：310018
            </p>
          </li>
          </ul>
<!--          <ul class="text_center">-->
<!--            <li>→融合内户</li>-->
<!--            <li>→车辆违章查询</li>-->
<!--            <li>→社保服务</li>-->
<!--          </ul>-->
        </li>
        <li class="threeRow hiddenNow">
          <p>→今日访问量：{{ getTodayVisit }}</p>
          <p>→共计访问量：{{  getTotalVisit }}</p>
        </li>
<!--        <li class="fourRow">-->
<!--          <img src="@/assets/images/codecrde.png" alt="">-->
<!--        </li>-->
        <li class="hiddenNow" style="position: absolute;
    bottom: 30px;
    right: 12%;">
          <p>→当前在线人数：{{ getNowVisit }}</p>
        </li>

      </div>
    </ul>
<!--    <ul class="bottomFooter layout text_center font_s_14">-->
<!--      <li>运营单位:信息化建设与管理中心</li>-->
<!--      <li>地址:江苏省宿迁市黄河南路399号邮编: 223800</li>-->
<!--    </ul>-->
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'commonFooter',
  computed: {
    ...mapGetters(['getTodayVisit', 'getTotalVisit', 'getNowVisit' ]),
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/commonFooter.vue